import React from 'react';
import { clickPreferredSourceBadge } from "../../../helpers/datalayer-utils";
import './google-badge-strip.m.css';

const GoogleBadgeStrip = ({ story = {} }) => {
  return (
    <button styleName="button-click" onClick={() => clickPreferredSourceBadge(story)}>
      <a styleName="parent" href="https://www.google.com/preferences/source?q=ndtvprofit" target="_blank">
        <div styleName="badge-class"></div>
      </a>
    </button>
  );
};

export default GoogleBadgeStrip;
